import { Flex } from "@chakra-ui/react";

type Props = {
  breadcrumb: React.ReactNode;
  heading: React.ReactNode;
  children: React.ReactNode;
};
export const AdminPage: React.FC<Props> = ({
  breadcrumb,
  heading,
  children,
}) => {
  return (
    <Flex direction="column" minHeight="100%" gap="10">
      {breadcrumb}
      {heading}
      {children}
    </Flex>
  );
};
